import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { WorkflowRequestInterceptorModule } from './core/interceptor/workflow-request-interceptor.module';
import { StyleSheetService } from '@shared/Services/stylesheet.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { WorkflowRoutes } from './app-routing.module'
import { RouterModule } from '@angular/router';
import { DynamicScriptLoaderService } from '@shared/Services/dynamicScriptLoader.service';
import { BiolomicsDatabaseService } from './services/biolomics-database.service';
import { WebsiteGlobalSettingsService } from '@shared/Services/website-globalsettings-service';
import { FlowTenantGuardService } from './services/flow-tenant-guard.service';
import { FlowAuthenticationdGuardService } from './services/flow-authentication.service';
import { FileService, FlowAccountService, FlowCustomerService, WorkflowNotificationService } from './services';
import { FlowRemoteDatabaseService } from './services/flow-remote-database.service';
import { RemoteDatabaseGuardService } from './services/remote-database-guard.service';
import { ConfigService } from 'src/config/config.service';
import { environment } from 'src/wf/environments/environment';
import { IS_BACKEND, WORKFLOW_BASE_URL } from '@shared/Models/constants';
import { SAVER, getSaver } from './providers/file-saver.provider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DockModal } from 'tools/DockModal/dock-modal';
import { WorkflowRoutingService } from './services/flow-Routing.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { PreviousRouteService } from '@shared/Services/previous-route.service';
import { DateUTCService } from '@shared/Services/DateUTC.service';
import {CustomDateAdapter, CustomMatNativeDateModule} from '@shared/date.module';



import { VexModule } from '@vex/vex.module';
import { catchError, of, tap } from 'rxjs';
//import { RemoteDatabaseInterceptorService } from './core/interceptor/remote-database-interceptor.service';
//import { NgxSpinnerModule } from "ngx-spinner";

export function appInitializerFactory(
  webSiteConfigService: WebsiteGlobalSettingsService, 
  workflowNotificationService: WorkflowNotificationService,
  flowAccountService: FlowAccountService
) {
  return () => {
  
    if (flowAccountService.isAuthenticated()) {
      workflowNotificationService.startConnection().pipe(
        tap(() => {
          setInterval(() => {
            workflowNotificationService.checkConnectionHealth();
          }, 60000); 
        }),
        catchError((error) => {
          return of(null);
        })
      ).subscribe();
    } else {
    }

    return webSiteConfigService.fetchSettings();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    //AppRoutingModule,
    RouterModule.forRoot(WorkflowRoutes, {
      // preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    }),
    BrowserAnimationsModule,
    HttpClientModule,
    MatSnackBarModule,
    WorkflowRequestInterceptorModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      closeButton: true,
      progressBar: true
    }),
    // Vex
    VexModule,
    CustomLayoutModule,
    //NgxSpinnerModule
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [WebsiteGlobalSettingsService, WorkflowNotificationService, FlowAccountService],
      useFactory: appInitializerFactory
    },
    {
      provide: WORKFLOW_BASE_URL,
      useValue: environment.workflowBaseUrl
    },
    {
      provide: IS_BACKEND,
      useValue: true
    },
    WebsiteGlobalSettingsService,
    DockModal,
    DynamicScriptLoaderService,
    StyleSheetService,
    ToastrService,
    BiolomicsDatabaseService,
    FlowAuthenticationdGuardService,
    FlowTenantGuardService,
    FlowCustomerService,
    FlowRemoteDatabaseService,
    RemoteDatabaseGuardService,
    FileService,
    WorkflowRoutingService,
    FlowAccountService,
    PreviousRouteService,
    {
      provide: SAVER,
      useValue: getSaver()
    },
    DateUTCService,
    CustomDateAdapter
    //RemoteDatabaseInterceptorService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
